module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 256
// module chunks = 0